import { Stack, Text,Label,TextField, CommandBarButton, TooltipHost, DirectionalHint, FontIcon,IChoiceGroupOption, ChoiceGroup } from '@fluentui/react'
import React, { Fragment, useState,useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Type from '../../../Redux/Type';
import * as XLSX from "xlsx";
import { DichChuyenDuong, LineToPolyGon } from '../../../Containers/GiaoCatPolygons';
import { onMoveToMap } from '../../../Containers/MapView';

const sheetNames = ["Info","Coordinates"]

const options: IChoiceGroupOption[] = [
  {
    key: 'DAT',
    imageSrc: process.env.PUBLIC_URL + '/images/icons/plot.png',
    imageAlt: 'Quy hoạch đất',
    selectedImageSrc:process.env.PUBLIC_URL + '/images/icons/plot-active.png',
    imageSize: { width: 24, height: 24 },
    text: '',
  },
  {
    key: 'DNG',
    imageSrc:process.env.PUBLIC_URL + '/images/icons/street.png',
    imageAlt: 'Quy Hoạch Đường',
    selectedImageSrc: process.env.PUBLIC_URL + '/images/icons/street-active.png',
    imageSize: { width: 24, height: 24},
    text: '',
  },
];

const DrawingManager = () => {
  const dispatch = useDispatch();
  const {listPoints, textInput, textInputLoGioi} = useSelector(state=>state.drawingTool);
  const txtInput = useRef()
  const txtRongDuong= useRef()
  // Loại quy hoạch phân DAT: đất , 
  const [loaiQuyHoach, setLoaiQuyHoach] = useState('DAT');

  
  const setTitle = () =>{
    try {
      let arrImg = document.getElementById('chose-gr-v').getElementsByTagName('img')
      for(let i = 0; i< arrImg.length; i++){
        if(arrImg[i].src.includes('plot'))
          arrImg[i].setAttribute('title', 'Vẽ Quy Hoạch Đất')
        else
          arrImg[i].setAttribute('title', 'Vẽ Quy Hoạch Đường')
      }
    } catch (error) {
      
    }
    
  }
  useEffect (() => {
    dispatch({ type: Type.SET_MAIN_MESSAGE, message: null});
    setTitle()
  },[])

  const onVeQuyHoach = () => {
    try {
      let toaDo = txtInput.current.value
      if(!toaDo){
          alert('Vui lòng nhập danh sách tọa độ điểm quy hoạch')
      }
      else{
          let arrToaDo = toaDo.split('|')
         if(loaiQuyHoach === 'DAT')
            veQHThuaDat(arrToaDo)
         else if(loaiQuyHoach === 'DNG')
            veQHDuong(arrToaDo)
      }
    } catch (error) {
        console.log(error)
        alert('Lỗi khi thực hiện vẽ quy hoạch, vui lòng kiểm tra lại thông tin nhập')
    }
      
  }

  const veQHDuong = (arrToaDo) =>{
      if(arrToaDo.length < 2 ){
        return alert('Số điểm tọa độ không đủ để vẽ quy hoạch')
      }
      if(textInputLoGioi === null){
        return alert('Chưa nhập lộ giới')
      }
      dispatch({ type: Type.SET_DRAWING_POINT,evt: [] })
      let arrToaDoN =  arrToaDo.map(e=>{

        let points = e.replace('(','').replace(')','').split(',')
        
        return {lat: parseFloat(points[0]) , lng: parseFloat(points[1])}
      })
      dispatch({ type: Type.SET_DRAWING_LINE,evt: arrToaDoN })
      arrToaDoN =  arrToaDo.map(e=>{
        let points = e.replace('(','').replace(')','').split(',')
        return [parseFloat(points[0]) , parseFloat(points[1])]
      })
      let line1 = DichChuyenDuong(arrToaDoN,textInputLoGioi/2)
      let line2 = DichChuyenDuong(arrToaDoN,textInputLoGioi/2 * -1)
      line2 = line2.reverse();
      line1 = line1.concat(line2)
      arrToaDoN =  line1.map(e=>{
        return {lat: e[0] , lng: e[1]}
      })
      dispatch({ type: Type.SET_DRAWING_POINT,evt: arrToaDoN })
      onMoveToMap(arrToaDoN[0])
  }

  const veQHThuaDat = (arrToaDo) =>{
    if(arrToaDo.length < 3  ){
      alert('Số điểm tọa độ không đủ để vẽ quy hoạch')
    }
    else{
      dispatch({ type: Type.SET_DRAWING_POINT,evt: [] })
      let arrToaDoN =  arrToaDo.map(e=>{

        let points = e.replace('(','').replace(')','').split(',')
        
        return {lat: parseFloat(points[0]) , lng: parseFloat(points[1])}
      })
      dispatch({ type: Type.SET_DRAWING_POINT,evt: arrToaDoN })
      onMoveToMap(arrToaDoN[0])
    }
  }
  const getFileTemplate =() =>{
      let fileLink =   process.env.PUBLIC_URL + loaiQuyHoach === 'DAT' ? '/template-file/template_import_quyhoach.xlsx' :  '/template-file/template_import_quyhoach-line.xlsx'
      const link = document.createElement('a')
      link.href = fileLink;
      link.download = "template_import_quyhoach";
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)  
  }
  const ChangeLoaiVe = (e,item) =>{
    clearAllData()
    setLoaiQuyHoach(item.key)
  }
  const onCheckQuyHoach = () =>{
    if(listPoints.length >0)
      dispatch({type:Type.SET_SHOW_MAIN_MODAL})
    else
      alert('Thực hiện vẽ quy hoạch trước khi xem thông tin')
  }
  const uploadFile =(event)=>{
    try {
     
      let file = event.target.files[0];
      
      if (file) {
       
        var reader = new FileReader();
        reader.onload = (evt) => {
          const bstr = evt.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          let sheets =  wb.SheetNames
          for( let i = 0; i < sheetNames.length; i++){
            const wsname = sheets.filter(e=>e ===sheetNames[i] )[0];
            if(!wsname){
              alert("File nhập không đúng , vui lòng kiểm tra lại")
              break;
            }
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws);
            if(wsname === 'Info'){
            }
            else if(wsname=== 'Coordinates'){
                if(!data || data.length < 2 ){
                    alert('Số tọa độ phải từ 3 điểm trở lên!')
                }
                else{
                  dispatch({ type: Type.SET_DRAWING_TEXT_INPUT,evt: '' })
                  let count = data.length
                  let strNew  = ""
                  data.forEach((e,index)=>{
                    strNew += index === count -1 ?  `(${e.Lat},${e.Lng})` : `(${e.Lat},${e.Lng}) | `
                  })
                    dispatch({ type: Type.SET_DRAWING_TEXT_INPUT,evt: strNew })
                 
                }
            }
          
          }
        };
        reader.readAsBinaryString(file)
      }
    } catch (error) {
      alert("Lỗi trong quá trình xử lý, vui lòng kiểm tra lại dữ liệu")
    }
  
  }
  const clearAllData =() =>{
    dispatch({ type: Type.SET_DRAWING_TEXT_INPUT,evt: null })
    dispatch({ type: Type.SET_DRAWING_TEXT_INPUT_LOGIOI,evt: null })
    dispatch({ type: Type.SET_DRAWING_LINE,evt: [] })
    dispatch({ type: Type.SET_DRAWING_POINT,evt: [] })
  }
    return (
        <Fragment>
            <div className='modal-content-container'>
                <div className='animated-panel'>
                    <Text variant='xLarge' className='title'>Vẽ quy hoạch</Text>
                    <Stack tokens={{ childrenGap: 20 }} style={{ flex: 1 }}>
                    <ChoiceGroup id="chose-gr-v" style={{fontFamily: 'Open Sans'}} label="Chọn Loại Quy Hoạch"
                    onChange={ChangeLoaiVe}
                     styles={styles.choseGroup} defaultSelectedKey="DAT" options={options} />
                    <Stack tokens={{ childrenGap: 5 }}>
                        <Label>{loaiQuyHoach === 'DAT' ? 'Nhập danh sách điểm' : 'Nhập danh sách vẽ tim đường'}</Label>
                        <Stack style={{marginBottom:0}} horizontal  >
                          <TooltipHost 
                                content='Đính kèm danh sách tọa độ'
                                styles={{ root: { display: 'inline-block' } }}
                                directionalHint={DirectionalHint.bottomCenter}
                            >
                          <label className="custom-file-upload">
                              <FontIcon aria-label="BulkUpload" iconName="BulkUpload" style={{padding:2}} className={'custom-file-upload-ico'} />
                              <input type="file"   accept=".xlsx" 
                                 onClick={(event)=> {
                                  event.target.value = null
                                }}
                              onChange={(evt)=>{uploadFile(evt)}} />
                          </label>
                          </TooltipHost>
                          <TooltipHost
                            
                                content='Tải mẫu file đính kèm'
                                styles={{ root: { display: 'inline-block', marginLeft:0 } }}
                                directionalHint={DirectionalHint.bottomCenter}
                            >
                             
                             <label className="custom-file-upload"  onClick={getFileTemplate}>
                                <FontIcon aria-label="Download" iconName="Download" style={{padding:2}} className={'custom-file-upload-ico'} />
                             </label>
                          </TooltipHost>
                          <TooltipHost
                                content='Xóa dữ liệu'
                                styles={{ root: { display: 'inline-block' } }}
                                directionalHint={DirectionalHint.bottomCenter}
                            >
                              <label className="custom-file-upload" onClick={clearAllData}>
                                <FontIcon aria-label="Delete" iconName="Delete" style={{padding:2}} className={'custom-file-upload-ico'} />
                              </label>
                          </TooltipHost>
                          <TextField label=""
                            value={textInputLoGioi}
                             onChange={(ev,value)=> !isNaN(+value) === true ? dispatch({ type: Type.SET_DRAWING_TEXT_INPUT_LOGIOI,evt: value }) : null}
                             ref={txtRongDuong}
                           disabled={loaiQuyHoach === 'DAT'} placeholder="Độ rộng (mét)" />  
                        </Stack>
                        <Stack horizontal style={{marginTop:0}} tokens={{ childrenGap: 20 }}>
                            
                            <TextField styles={styles.textbox}
                              onChange={(ev,value)=> {dispatch({ type: Type.SET_DRAWING_TEXT_INPUT,evt: value })} }
                              value={textInput}
                              ref={txtInput}
                              placeholder={'(lat,lng) | (lat,lng)...'}
                              description={`Nhập tọa độ theo thứ tự ${loaiQuyHoach === 'DAT' ? 'đa giác' :'đường thẳng' }, mỗi điểm cách nhau dấu < | > `}                             multiline rows={7} />   
                        </Stack>
                        
                        <Stack horizontal tokens={{ childrenGap:10 }}>
                          <TooltipHost
                                content=''
                                styles={{ root: { display: 'inline-block' } }}
                                directionalHint={DirectionalHint.bottomCenter}
                            >
                              <CommandBarButton  iconProps={{ iconName: 'Handwriting' }}
                              onClick={()=>onVeQuyHoach()}
                               text={'Vẽ quy hoạch'} styles={styles.buttonDraw} />
                          </TooltipHost>
                          <TooltipHost
                                content=''
                                styles={{ root: { display: 'inline-block' } }}
                                directionalHint={DirectionalHint.bottomCenter}
                            >
                              <CommandBarButton  iconProps={{ iconName: 'SearchAndApps' }}
                              onClick={onCheckQuyHoach}
                               text={'Kiểm tra'} styles={{...styles.buttonDraw,root:{...styles.buttonDraw.root, backgroundColor:  'rgb(69, 161, 170)'}}} />
                          </TooltipHost>
                        </Stack>
                    </Stack>
                    </Stack>
                </div>
            </div>
        </Fragment>
    )
}
export default DrawingManager

const styles = {
    textbox: {
        root: {
            width: '100%'
        },
        field:{
          fontSize:12
        }
    },
    buttonDelete:{
      root: {
        marginLeft: '0px !important',
        padding: '6px 5px'
,
        borderRadius: '5px',
        backgroundColor: 'transparent',
      },
      icon: {
        fontSize: 16,
        color: '#515151'
      }
    },
    choseGroup: {
      flexContainer: [
        {
          selectors: {
            ".ms-ChoiceField-innerField": {
              paddingRight: 40,
              paddingLeft: 11
            },
            ".ms-ChoiceField-labelWrapper":{
                height: 5
            }
          }
        }
      ]
    },
    buttonDraw:{
      root: {
        padding: '6px 5px',
        borderRadius: '5px',
        backgroundColor:  '#3684c8',
        marginRight: 3
      },
      rootHovered:{
        backgroundColor: '#60a5e1',
      },
      label: {
          fontSize: 12,
          color: 'white'
      },
      iconHovered: {
        fontSize: 16,
        color: 'white'
      },
      icon: {
          fontSize: 16,
          color: 'white'
      }
    }
}

// const CustomLabel = (props: ITextFieldProps): JSX.Element => {
//     const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
//     const descriptionId: string = useId('description');
//     const iconButtonId: string = useId('iconButton');
  
//     return (
//       <>
//         <Stack horizontal verticalAlign="center" tokens={stackTokens}>
//           <span id={props.id}>{props.label}</span>
//           <IconButton
//             id={iconButtonId}
//             iconProps={iconProps}
//             title="Info"
//             ariaLabel="Info"
//             onClick={toggleIsCalloutVisible}
//             styles={iconButtonStyles}
//           />
//         </Stack>
//         {isCalloutVisible && (
//           <Callout
//             target={'#' + iconButtonId}
//             setInitialFocus
//             onDismiss={toggleIsCalloutVisible}
//             ariaDescribedBy={descriptionId}
//             role="alertdialog"
//           >
//             <Stack tokens={stackTokens} horizontalAlign="start" styles={labelCalloutStackStyles}>
//               <span id={descriptionId}>The custom label includes an IconButton that displays this Callout on click.</span>
//               <DefaultButton onClick={toggleIsCalloutVisible}>Close</DefaultButton>
//             </Stack>
//           </Callout>
//         )}
//       </>
//     );
//   };